import { ResolveFn } from '@angular/router';
import {Infofragments} from "@models/Infofragments.model";
import {inject} from "@angular/core";
import {APIService} from "@shared/api.service";
import {map} from "rxjs";

export const infofragmentsResolver: ResolveFn<Infofragments> = (route, state) => {
  const apiService = inject(APIService);
  let channel = route.params['channel'];
  return apiService.get('infofragments.json/?category='+channel).pipe(map((res: Infofragments) => {
    res.results.forEach(item => {
      if(item.locked_by !== null) {
        item.status = 'current';
      }
    })
    return res;
  }));
};
